import OverallResultsBox from './OverallResultsBox';

export default OverallResultsBox;
